module.exports={name:"第10章 誓い",number:10};